var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mft-c-table--scroll"},[_c('table',{staticClass:"mft-c-table--scroll__table"},[_c('thead',[_vm._t("header")],2),_c('tbody',[_vm._t("body")],2),_c('tfoot',[_vm._t("footer")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }